import { Outlet, createRootRoute } from '@tanstack/react-router';
import * as Sentry from '@sentry/react';
import { describeError } from '@s2w/core';

const includeErrorDetails = import.meta.env.DEV;

const RootFallback = ({ error }: { error: unknown }) => (
  <main
    role="alert"
    className="bg-terrain-black text-text-light flex min-h-dvh items-center justify-center p-6"
  >
    <div className="max-w-md space-y-2 text-center">
      <h1 className="text-xl font-semibold">Something went wrong</h1>
      <p className="text-text-light-grey text-sm">
        {describeError(error, { includeDetails: includeErrorDetails })}
      </p>
    </div>
  </main>
);

const RootComponent = () => (
  <Sentry.ErrorBoundary fallback={({ error }) => <RootFallback error={error} />}>
    <Outlet />
  </Sentry.ErrorBoundary>
);

export const Route = createRootRoute({
  component: RootComponent,
});
